/* BM7 chat widget - vanilla port of the BM7 reference widget.
   Preserves the original behaviour: quick replies, message send, open/close,
   typing indicator and local assistant replies. */
(function () {
  'use strict';

  var ICONS = {
    messageCircle:
      '<svg viewBox="0 0 24 24" width="27" height="27" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>',
    close:
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
    closeLauncher:
      '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>',
    send:
      '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"/><path d="m21.854 2.147-10.94 10.939"/></svg>',
    packageCheck:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m16 16 2 2 4-4"/><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"/><path d="M3.3 7 12 12l8.7-5"/><path d="M12 22V12"/></svg>',
    tag:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/></svg>',
    shirt:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z"/></svg>',
    sparkles:
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/><path d="M20 3v4"/><path d="M22 5h-4"/><path d="M4 17v2"/><path d="M5 18H3"/></svg>',
    whatsapp:
      '<svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true"><path d="M16.004 3.2A12.79 12.79 0 0 0 3.2 16c0 2.26.6 4.46 1.73 6.4L3.2 28.8l6.56-1.72A12.79 12.79 0 1 0 16.004 3.2zm0 23.05a10.24 10.24 0 0 1-5.22-1.43l-.37-.22-3.89 1.02 1.04-3.79-.24-.39a10.26 10.26 0 1 1 8.68 4.81zm5.62-7.68c-.31-.16-1.82-.9-2.1-1-.28-.1-.49-.16-.7.16-.2.31-.8 1-.98 1.2-.18.2-.36.23-.67.08-.31-.16-1.3-.48-2.48-1.53-.92-.82-1.54-1.83-1.72-2.14-.18-.31-.02-.48.14-.63.14-.14.31-.36.47-.55.16-.18.2-.31.31-.52.1-.2.05-.39-.03-.55-.08-.16-.7-1.69-.96-2.31-.25-.6-.5-.52-.7-.53l-.6-.01c-.2 0-.53.08-.8.39-.28.31-1.06 1.03-1.06 2.51 0 1.48 1.08 2.91 1.23 3.11.15.2 2.13 3.25 5.16 4.56.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.82-.74 2.07-1.46.26-.72.26-1.34.18-1.46-.08-.13-.28-.2-.59-.36z"/></svg>'
  };

  var QUICK_REPLIES = [
    { label: 'Track my order', prompt: 'I want to track my order', icon: 'packageCheck' },
    { label: 'Sales & discounts', prompt: 'Are there any sales or discounts available?', icon: 'tag' },
    { label: 'Fabric guide', prompt: 'Help me choose a fabric', icon: 'shirt' },
    { label: 'Perfumes', prompt: 'Tell me about BM7 perfumes', icon: 'sparkles' }
  ];

  var INITIAL_MESSAGE =
    "Assalam o alaikum. I'm your BM7 style assistant. Ask me about fabrics, perfumes, wallets, orders, or today's best picks.";

  function getBotReply(message) {
    var text = String(message).toLowerCase();

    if (text.indexOf('track') !== -1 || text.indexOf('order') !== -1) {
      return 'Sure. Please share your order number and phone number used at checkout. I can guide the flow here, and this can later connect directly to Shopify order tracking.';
    }
    if (text.indexOf('sale') !== -1 || text.indexOf('discount') !== -1 || text.indexOf('offer') !== -1) {
      return 'BM7 usually highlights active offers in the Sale section. For a premium pick, I can also suggest pieces that feel like the best value today.';
    }
    if (
      text.indexOf('fabric') !== -1 ||
      text.indexOf('cotton') !== -1 ||
      text.indexOf('boski') !== -1 ||
      text.indexOf('lattha') !== -1
    ) {
      return 'For daily wear, choose soft cotton. For a refined traditional look, Boski feels richer. For crisp summer styling, Lattha is a clean choice.';
    }
    if (
      text.indexOf('perfume') !== -1 ||
      text.indexOf('fragrance') !== -1 ||
      text.indexOf('moonlight') !== -1 ||
      text.indexOf('oud') !== -1
    ) {
      return 'For perfume, Moonlight feels fresh and versatile, Oud leans bold and evening-ready, and 7 Gold gives a more signature premium impression.';
    }
    if (text.indexOf('wallet') !== -1 || text.indexOf('gift') !== -1) {
      return 'A leather wallet or perfume gift box is the easiest premium gift. Tell me the occasion and budget, and I will narrow it down.';
    }
    return 'Nice choice. Tell me if you are shopping for daily wear, a wedding look, perfume, or gifting, and I will recommend the most suitable BM7 option.';
  }

  function el(tag, className, attrs) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        node.setAttribute(key, attrs[key]);
      });
    }
    return node;
  }

  function init() {
    var root = document.getElementById('bm7-chatbot-root');
    if (!root || root.getAttribute('data-bm7-ready') === 'true') return;
    root.setAttribute('data-bm7-ready', 'true');

    var state = { isOpen: false, isTyping: false, messageCount: 0, isExpanded: false };

    var widget = el('div', 'bm7-widget', { 'aria-live': 'polite', 'data-open': 'false' });

    /* Panel */
    var panel = el('section', 'bm7-panel', { 'aria-label': 'BM7 chatbot' });

    var glow = el('div', 'bm7-panel__glow');

    var header = el('header', 'bm7-header');
    var avatar = el('div', 'bm7-avatar', { 'aria-hidden': 'true' });
    var avatarMark = el('span', 'bm7-avatar__mark');
    avatarMark.textContent = 'BM7';
    avatar.appendChild(avatarMark);

    var headerText = el('div');
    var eyebrow = el('p', 'bm7-eyebrow');
    eyebrow.textContent = 'BM7 Assistant';
    var title = el('h2');
    title.textContent = 'Your personal style concierge';
    var status = el('span', 'bm7-status');
    status.appendChild(el('i'));
    status.appendChild(document.createTextNode('Online now'));
    headerText.appendChild(eyebrow);
    headerText.appendChild(title);
    headerText.appendChild(status);

    var closeButton = el('button', 'bm7-icon-button', { type: 'button', 'aria-label': 'Close chat' });
    closeButton.innerHTML = ICONS.close;

    header.appendChild(avatar);
    header.appendChild(headerText);
    header.appendChild(closeButton);

    var messages = el('div', 'bm7-messages');

    var quickReplies = el('div', 'bm7-quick-replies', { 'aria-label': 'Instant answers' });
    var quickButtons = [];
    QUICK_REPLIES.forEach(function (reply) {
      var button = el('button', null, { type: 'button' });
      button.innerHTML = ICONS[reply.icon] + '<span>' + reply.label + '</span>';
      button.addEventListener('click', function () {
        sendMessage(reply.prompt);
      });
      quickButtons.push(button);
      quickReplies.appendChild(button);
    });

    var composer = el('form', 'bm7-composer');
    var input = el('input', null, {
      type: 'text',
      placeholder: 'Write message...',
      'aria-label': 'Write message'
    });
    var sendButton = el('button', null, { type: 'submit', 'aria-label': 'Send message' });
    sendButton.innerHTML = ICONS.send;
    sendButton.disabled = true;
    composer.appendChild(input);
    composer.appendChild(sendButton);

    panel.appendChild(glow);
    panel.appendChild(header);
    panel.appendChild(messages);
    panel.appendChild(quickReplies);
    panel.appendChild(composer);

    /* ---- Speed-dial launcher: one FAB that reveals WhatsApp + AI chat ---- */
    var dock = el('div', 'bm7-dock', { 'data-expanded': 'false' });

    var actions = el('div', 'bm7-dock__actions', { 'aria-label': 'Chat options' });

    var aiBtn = el('button', 'bm7-dock__act bm7-dock__act--ai', {
      type: 'button',
      'aria-label': 'Open BM7 AI chat'
    });
    aiBtn.innerHTML = '<span class="bm7-dock__tip">AI Chat</span>' + ICONS.sparkles;

    var waBtn = el('button', 'bm7-dock__act bm7-dock__act--wa', {
      type: 'button',
      'aria-label': 'Chat on WhatsApp'
    });
    waBtn.innerHTML = '<span class="bm7-dock__tip">WhatsApp</span>' + ICONS.whatsapp;

    /* AI on top, WhatsApp closest to the FAB (bottom of the revealed stack) */
    actions.appendChild(aiBtn);
    actions.appendChild(waBtn);

    var launcher = el('button', 'bm7-launcher', {
      type: 'button',
      'aria-label': 'Open chat options',
      'aria-expanded': 'false',
      'aria-haspopup': 'true'
    });
    var fabIcon = el('span', 'bm7-launcher__icon');
    fabIcon.innerHTML = ICONS.messageCircle;
    launcher.appendChild(fabIcon);
    var unread = el('span', 'bm7-unread');
    unread.textContent = '1';
    launcher.appendChild(unread);

    dock.appendChild(actions);
    dock.appendChild(launcher);

    widget.appendChild(panel);
    widget.appendChild(dock);
    root.appendChild(widget);

    function scrollToBottom() {
      messages.scrollTo({ top: messages.scrollHeight, behavior: 'smooth' });
    }

    function addMessage(role, text) {
      var row = el('div', 'bm7-message-row bm7-message-row--' + role);
      var bubble = el('div', 'bm7-bubble bm7-bubble--' + role);
      bubble.textContent = text;
      row.appendChild(bubble);
      messages.appendChild(row);
      state.messageCount += 1;
      scrollToBottom();
    }

    function showTyping() {
      var row = el('div', 'bm7-message-row bm7-message-row--bot');
      row.setAttribute('data-bm7-typing', 'true');
      var bubble = el('div', 'bm7-bubble bm7-bubble--bot bm7-typing', {
        'aria-label': 'BM7 assistant is typing'
      });
      bubble.appendChild(el('span'));
      bubble.appendChild(el('span'));
      bubble.appendChild(el('span'));
      row.appendChild(bubble);
      messages.appendChild(row);
      scrollToBottom();
      return row;
    }

    function setQuickDisabled(disabled) {
      quickButtons.forEach(function (button) {
        button.disabled = disabled;
      });
    }

    function syncSendDisabled() {
      sendButton.disabled = !input.value.trim() || state.isTyping;
    }

    function sendMessage(text) {
      var trimmed = String(text).trim();
      if (!trimmed || state.isTyping) return;

      hideUnread();
      addMessage('user', trimmed);
      input.value = '';
      state.isTyping = true;
      setQuickDisabled(true);
      syncSendDisabled();

      var typingRow = showTyping();

      window.setTimeout(function () {
        if (typingRow && typingRow.parentNode) {
          typingRow.parentNode.removeChild(typingRow);
        }
        addMessage('bot', getBotReply(trimmed));
        state.isTyping = false;
        setQuickDisabled(false);
        syncSendDisabled();
      }, 850);
    }

    function hideUnread() {
      if (unread.parentNode) unread.parentNode.removeChild(unread);
    }

    function updateFabIcon() {
      fabIcon.innerHTML = state.isOpen || state.isExpanded ? ICONS.closeLauncher : ICONS.messageCircle;
    }

    function setExpanded(expanded) {
      if (state.isOpen) expanded = false;
      state.isExpanded = expanded;
      dock.setAttribute('data-expanded', expanded ? 'true' : 'false');
      launcher.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      updateFabIcon();
    }

    function setOpen(open) {
      state.isOpen = open;
      widget.setAttribute('data-open', open ? 'true' : 'false');
      launcher.setAttribute('aria-label', open ? 'Close BM7 chat' : 'Open chat options');
      if (open) setExpanded(false);
      updateFabIcon();
      if (open) {
        hideUnread();
        window.setTimeout(function () {
          scrollToBottom();
          input.focus();
        }, 280);
      }
    }

    function openWhatsApp() {
      var appButton = document.getElementById('whatflow-main-button');
      if (appButton) {
        appButton.click();
        return;
      }
      window.open('https://wa.me/923254444800', '_blank', 'noopener');
    }

    /* Desktop: reveal on hover (with a small close delay so the cursor can
       travel to the icons). Touch devices use click/tap instead. */
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var collapseTimer = null;

    if (hoverCapable) {
      dock.addEventListener('mouseenter', function () {
        window.clearTimeout(collapseTimer);
        if (!state.isOpen) setExpanded(true);
      });
      dock.addEventListener('mouseleave', function () {
        collapseTimer = window.setTimeout(function () {
          setExpanded(false);
        }, 320);
      });
    }

    launcher.addEventListener('click', function () {
      if (state.isOpen) {
        setOpen(false);
        return;
      }
      setExpanded(!state.isExpanded);
    });

    waBtn.addEventListener('click', function () {
      setExpanded(false);
      openWhatsApp();
    });

    aiBtn.addEventListener('click', function () {
      setOpen(true);
    });

    /* Tap outside collapses the speed-dial (mainly for touch). */
    document.addEventListener('click', function (event) {
      if (state.isExpanded && !dock.contains(event.target)) setExpanded(false);
    });

    closeButton.addEventListener('click', function () {
      setOpen(false);
    });

    input.addEventListener('input', syncSendDisabled);

    composer.addEventListener('submit', function (event) {
      event.preventDefault();
      sendMessage(input.value);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (state.isOpen) setOpen(false);
      else if (state.isExpanded) setExpanded(false);
    });

    addMessage('bot', INITIAL_MESSAGE);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
